import { getUserId } from '@/utils/userUtils'

const getConfigEnv = () => {
  const customEnv = process.env.customEnv
  if (['prod', 'pre'].includes(customEnv)) return customEnv
  return 'test'
}

export const initDUOTEL = () => {
  if (window.DUOTEL) {
    window.DUOTEL &&
      window.DUOTEL.setConfig({
        appId: 'duapp-poizon-service',
        env: getConfigEnv(),
        userIn: getUserId(),
        area: 'sgprd-plus',
        appName: 'hybrid-ssr',
        businessType: '国际业务域',
        type: 'C',
        ignoreUrls: ['/aliyun-oss/logs'],
        ignoreErrors: [
          '请先登录',
          'Network Error',
          'No error message',
          'The system is busy',
          '非法的地区参数',
          'missing /',
          'Request aborted'
        ]
      })
  }
}
